import Color from 'color'
import { EventStatus } from '../../models/Event'
import { colors, labels } from '../../models/Event/eventConfig'
import tags from './tags'
import { IUserObjectStore } from './index'

export default {
  countryDictionary: [],
  currency: [],
  financeRequest: {
    acceptedCount: 0,
    errMessage: '',
    isLoading: true,
    isSaving: false,
  },
  objectType: [],
  profileRequest: {
    acceptedCount: 0,
    errMessage: '',
    isLoading: true,
    isSaving: false,
  },
  settingsRequest: {
    acceptedCount: 0,
    errMessage: '',
    isLoading: true,
    isSaving: false,
  },
  tags,
  userObject: {
    profile: undefined,
    settings: {
      customReservationStatus: {
        colors: {
          [EventStatus.Advance]: Color(colors.get(EventStatus.Advance)),
          [EventStatus.Canceled]: Color(colors.get(EventStatus.Canceled)),
          [EventStatus.Full]: Color(colors.get(EventStatus.Full)),
          [EventStatus.Unavailable]: Color(colors.get(EventStatus.Unavailable)),
          [EventStatus.NoPayment]: Color(colors.get(EventStatus.NoPayment)),
        },
        names: {
          [EventStatus.Advance]: labels.get(EventStatus.Advance),
          [EventStatus.Canceled]: labels.get(EventStatus.Canceled),
          [EventStatus.Full]: labels.get(EventStatus.Full),
          [EventStatus.Unavailable]: labels.get(EventStatus.Unavailable),
          [EventStatus.NoPayment]: labels.get(EventStatus.NoPayment),
        },
      },
    },
  },
} as IUserObjectStore
